import _ from "lodash";
import React from "react";
import classes from "./SelectAttachmentComponent.scss";
import { Button, DSProvider } from "@toddle-edu/ds-web";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import { AttachmentList } from "Attachment";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import NotAddedEmptyView from "UIComponents/NotAddedEmptyView";
import { connect } from "react-redux";
import { updateField } from "modules/FieldUpdateThunks";
import { withRouter } from "react-router";
import ModalComponentWrapper from "./ModalComponentWrapper";

const styles = {
  attachmentContainerStyle: {
    gridTemplateColumns: "unset",
  },
};

class SelectAttachmentComponent extends UIBaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      showSelectModal: false,
    };
  }
  toggleModal = () => {
    const { showSelectModal } = this.state;
    this.setState({ showSelectModal: !showSelectModal });
  };

  createDropdownComponent = () => {
    const { buttonLabel, testId } = this.props;
    return (
      <div className={classes.selectContainer}>
        <Button
          type="outlined"
          variant="neutral"
          onClick={this.toggleModal}
          testId={`${testId}-createDropdown`}
        >
          {buttonLabel}
        </Button>
      </div>
    );
  };

  renderEdit = () => {
    const {
      value = [],
      options: { parentType, parentId },
      graphqlEnhancerQueryInfo,
      modalConfig,
      testId,
    } = this.props;

    const { showSelectModal } = this.state;

    return (
      <div className={classes.container}>
        <AttachmentList
          value={value}
          parentType={parentType}
          createDropdownComponent={this.createDropdownComponent()}
          showCreateDropdown={_.isEmpty(value)}
          parentId={parentId}
          shouldCallMutation={false}
          attachmentContainerStyle={styles.attachmentContainerStyle}
          cardType={"design-media-card"}
          updateInputField={value => {
            this.updateValue(value);
          }}
          dsVersion="2.0"
          testId={`${testId}-selectAttachment`}
        />
        {showSelectModal && (
          <DSProvider dsVersion="2.0">
            <ModalComponentWrapper
              modalConfig={modalConfig}
              updateValue={this.updateValue}
              toggleModal={this.toggleModal}
              parentType={parentType}
              parentId={parentId}
              graphqlEnhancerQueryInfo={graphqlEnhancerQueryInfo}
              testId={`${testId}-selectAttachment`}
            />
          </DSProvider>
        )}
      </div>
    );
  };

  renderView = () => {
    const {
      value = [],
      options: { parentType, parentId },
      disabled,
      childMode,
    } = this.props;

    return (
      <div className={classes.container}>
        <AttachmentList
          value={value}
          parentType={parentType}
          showCreateDropdown={false}
          parentId={parentId}
          shouldCallMutation={false}
          attachmentContainerStyle={styles.attachmentContainerStyle}
          cardType={"design-media-card"}
          updateInputField={value => {
            this.updateValue(value);
          }}
          mode={childMode}
          disabled={disabled}
          dsVersion="2.0"
        />
      </div>
    );
  };

  renderViewEmpty = () => {
    const { inputStyle = {} } = this.props;

    return <NotAddedEmptyView inputStyle={inputStyle} />;
  };
}

const mapStateToProps = (state, ownProps) => {
  const mode = _.get(ownProps, "disabled", false) ? "view" : ownProps?.mode;

  //Mode coming from ownProps will be passed as the same to the child components.
  const childMode = _.get(ownProps, "mode", "edit");

  return {
    mode,
    childMode,
  };
};

const mapActionCreators = {
  updateField,
};

export default compose(
  withRouter,
  I18nHOC({
    resource: ["project", "common"],
  }),
  connect(mapStateToProps, mapActionCreators)
)(SelectAttachmentComponent);
